var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorToast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "color",
    d: "M0 17H20L10 0L0 17ZM10.9091 14.3158H9.09091V12.5263H10.9091V14.3158ZM10.9091 10.7368H9.09091V7.15789H10.9091V10.7368Z",
    fill: "#B90F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorToast);
export default __webpack_public_path__ + "static/media/ErrorToast.38ab2abf053c3742bf6de572b333e043.svg";
export { ForwardRef as ReactComponent };